/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined} from "@mui/icons-material";

const Formulario_Check_Conductor = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >




                <Grid container size={6}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'}  dato={'nombres'} {...props}
                                  requerido={'Los Nombres son requeridos'} editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}
                                  requerido={'Los Apellidos son requeridos'} editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Numero de Cedula'} dato={'cc'} {...props}
                                  requerido={'El Numero de Cedula es requerido'} type={'number'} editable={false}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Check_Conductor